<app-nav-menu #navMenu [customerSelectionEnabled]="false"></app-nav-menu>

<div class="col-sm-11 center-block">
  <div class="row">
    <div class="col-sm-12">
      <h1 tabindex="0" role="heading" aria-label="Oops, the page you are looking for doesn't exist" aria-level="1">Oops, the page you are looking for doesn't exist</h1>
    </div>
  </div>
</div>

<app-footer #footer></app-footer>
